<script lang="ts">
  import { Switch as SwitchPrimitive } from "bits-ui";
  import { cn } from "$lib/utils.js";

  let {
    ref = $bindable(null),
    class: className,
    ...restProps
  }: SwitchPrimitive.ThumbProps = $props();
</script>

<SwitchPrimitive.Thumb
  bind:ref
  class={cn(
    "pointer-events-none block h-4 w-4 rounded-full bg-white shadow-lg ring-0 transition-transform",
    "data-[state=checked]:translate-x-4 data-[state=unchecked]:translate-x-0",
    className
  )}
  {...restProps}
/>
